import { render, staticRenderFns } from "./PublicationOpened05.vue?vue&type=template&id=26dafdfa&scoped=true"
import script from "./PublicationOpened05.vue?vue&type=script&lang=js"
export * from "./PublicationOpened05.vue?vue&type=script&lang=js"
import style0 from "./PublicationOpened05.vue?vue&type=style&index=0&id=26dafdfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dafdfa",
  null
  
)

export default component.exports